import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Button, Grid } from '@mui/material'
import VenueBoxMarketplace from '../../components/venue/VenueBoxMarketplace'
import FilterBar from 'components/common/FilterBar'
import SortDropdown from 'components/common/sortDropDown'
import FilterListIcon from '@mui/icons-material/FilterList'
import { getBackendUserUrl } from '../../utils/utils'
import AddressSearch from 'components/common/AddressSearch'
import { haversine } from '../../utils/utils'
import { UserContext } from 'contexts/UserContext'

const MarketplacePage = () => {
    const { user, loading, hasRole } = useContext(UserContext)
    const [venues, setVenues] = useState([])
    const [error, setError] = useState(false)
    const [sort, setSort] = useState('newest')
    const [filter, setFilter] = useState('All')
    const [priceRange, setPriceRange] = useState([0, 1000000])
    const [open, setOpen] = useState(false)
    const [minPrice, setMinPrice] = useState(0)
    const [maxPrice, setMaxPrice] = useState(1000)
    const [desiredCoordinates, setDesiredCoordinates] = useState(null)
    const [desiredMaxDistance, setDesiredMaxDistance] = useState(25)

    useEffect(() => {
        const fetchVenues = async () => {
            try {
                const apiUrl = getBackendUserUrl() + '/venue/venues'
                const response = await axios.post(apiUrl)
                if (Array.isArray(response.data.data)) {
                    setVenues(response.data.data)
                } else {
                    throw new Error('Response is not an array')
                }
            } catch (err) {
                setError(err.message)
            }
        }
        fetchVenues()
    }, [])

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    const handleApplyPriceFilter = () => {
        setPriceRange([minPrice, maxPrice])
        handleClose()
    }

    //TODO: Add filtering logic here after startPrice is implemented on backend
    // const filteredVenues = venues.filter(
    //     (venue) =>
    //         (filter === 'All' ||
    //             (venue.eventType && venue.eventType.includes(filter))) &&
    //         venue.startPrice >= priceRange[0] &&
    //         venue.startPrice <= priceRange[1]
    // )

    const sortVenues = (venues) => {
        switch (sort) {
            case 'oldest':
                return venues.sort(
                    (a, b) => new Date(a.created) - new Date(b.created)
                )
            case 'newest':
                return venues.sort(
                    (a, b) => new Date(b.created) - new Date(a.created)
                )
            case 'lowerPrice':
                return venues.sort((a, b) => a.startPrice - b.startPrice)
            case 'higherPrice':
                return venues.sort((a, b) => b.startPrice - a.startPrice)
            default:
                return venues
        }
    }

    useEffect(() => {
        if (desiredCoordinates) {
            const filterVenuesBasedOnDistance = (venues) => {
                return venues.filter((venue) => {
                    if (venue.latitude && venue.longitude) {
                        const distance = haversine(
                            desiredCoordinates[0],
                            desiredCoordinates[1],
                            venue.latitude,
                            venue.longitude
                        )
                        return distance <= desiredMaxDistance
                    }
                    return false // Skip venues without coordinates
                })
            }

            const filteredVenuesBasedOnDistance =
                filterVenuesBasedOnDistance(venues)
            setVenues(filteredVenuesBasedOnDistance)
        }
    }, [desiredCoordinates, desiredMaxDistance])

    const sortedVenues = sortVenues(venues)

    return (
        <div className="container-fluid px-4">
            <div>
                <div className="row justify-content-center">
                        <div
                            style={{
                                width: 'fit-content',
                                margin: '0 auto',
                                padding: '20px 0',
                            }}
                        >
                            <FilterBar setFilter={setFilter} />
                        </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                    }}
                >
                    <SortDropdown setSort={setSort} />
                    {hasRole(['admin']) && (
                        <div style={{ marginLeft: '10px' }}>
                            <AddressSearch
                                setCoordinates={setDesiredCoordinates}
                                setDistance={setDesiredMaxDistance}
                            />
                        </div>
                    )}
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    {/* Grid container for responsive layout */}
                    <Grid
                        container
                        spacing={3} // Consistent spacing
                        justifyContent="flex-start" // Changed from center to flex-start
                        sx={{
                            width: '100%',
                            margin: '0 auto', // Center the grid
                            padding: '0 16px', // Add some padding on the sides
                        }}
                    >
                        {/* Grid item for each venue */}
                        {sortedVenues.map((venue) => (
                            <Grid
                                item
                                key={venue.venueId}
                                sm={6} // 2 cards per row on small screens
                                md={3} // 3 cards per row on medium screens
                                lg={2} // 4 cards per row on large screens
                                xl={2} // 5 cards per row on extra-large screens
                            >
                                <VenueBoxMarketplace venue={venue} />
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </div>
        </div>
    )
}

export default MarketplacePage
